<main class="main">
    <div class="page-header text-center" style="background-image: url(assets/images/aboutus-new.jpg)">
        <div class="container">
            <h1 class="page-title">Buy Weed Online in Rye</h1>
        </div>
    </div>

    <div class="">
        <div class="container">
            <div class="row align-items-center mt-5">
                <div class="col-8">
                    <div class="heading-main">
                        <h2 class="title-lg" tabindex="0">New Arrivals</h2>
                        <p class="headeig_home_sub" tabindex="0" role="text">Check out our latest product</p>
                    </div>
                </div>
                <div class="col-4">
                    <div class="view-more-link cursor">
                        <a [ngStyle]="getColor('text')" tabindex="0" [routerLink]="['/shop/NewArrivals']">View More</a>
                    </div>
                </div>
            </div>
            <div>
                <app-product-listing [payLoad]="payload"></app-product-listing>
            </div>
        </div>
    </div>

    <div class="contactPage">
        <div class="container">
            <div class="DataPart">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <figure>
                            <img src="assets/images/but-weed.png" alt="Buy Weed Online Rye NY">
                        </figure>
                    </div>
                    <div class="col-md-6">
                        <h2>Buy Weed Online in Rye, NY</h2>
                        <p>If you're in Rye, NY and looking to buy cannabis online, you're in the right place. Just down
                            the road in New Rochelle, Highlife Health offers trusted, high-quality products with fast,
                            discreet delivery to your area. </p>
                        <p>Highlife Health, located nearby in New Rochelle, provides reliable, superior products with
                            prompt, fast delivery to your doorstep. With service as considerate as our product
                            selection, we make it simple for both new and seasoned cannabis users to order from a
                            licensed dispensary near Rye, NY. We believe cannabis should be accessible, secure, and
                            wellness-oriented.</p>

                    </div>
                </div>
                <h2>Looking for a Weed Dispensary Near Rye, NY? We're Just around the Corner.</h2>
                <p class="mb-2">At Highlife Health, we’re proud to be Westchester’s first woman-owned dispensary,
                    located just minutes from Rye. Our mission goes beyond selling cannabis—we’re here to help people
                    feel better, live better, and explore cannabis in a way that supports their health and happiness.
                </p>
                <p class="mb-3">Finding quality doesn't require traveling far. We are a reputable weed dispensary
                    serving Rye, NY with fast, and caring service.</p>

            </div>
        </div>
    </div>

    <div class="catName">
        <div class="container">
            <div class="catList">
                <ul>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Flower_flower')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/flower-c.png"
                            alt="Flower"><span>Flower</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Vapes_vaporizers')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/Vapes-c.png"
                            alt="Vapes"><span>Vapes</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Edibles_edibles')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/edibles-c.png"
                            alt="Edibles"><span>Edibles</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Pre roll_pre-rolls')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/Pre-roll-c.png"
                            alt="Pre Rolls"><span>Pre Rolls</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Concentrates_concentrates')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/Concentrates-c.png"
                            alt="Concentrates"><span>Concentrates</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Tinctures_tinctures')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/tincture-c.png"
                            alt="Tinctures"><span>Tinctures</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Topical_topical')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/topical-c.png"
                            alt="Topical"><span>Topical</span></li>
                    <li style="cursor: pointer;" (click)="routeMeTo('shop/Accessories_accessories')"><img
                            src="https://cova-common.s3.ca-central-1.amazonaws.com/Accessories-c.png"
                            alt="Accessories"><span>Accessories</span></li>
                </ul>
            </div>
        </div>
    </div>

    <div class="contactPage">
        <div class="container">
            <div class="DataPart">
                <h2 class="mb-4 text-center">Why Rye Locals Love Highlife Health</h2>
                <div class="row">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="boxes-four text-center">
                                    <h4>Wellness First,<br>Always</h4>
                                    <p>Every product we carry is hand-selected with your wellbeing in mind, ranging from
                                        edibles, topicals, and tinctures to premium flower and vapes. We have solutions
                                        for pain management, relaxation, and sleep.</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="boxes-four text-center">
                                    <h4>Reliable Weed<br>Delivery in Rye, NY</h4>
                                    <p>Want to skip the drive? We offer discreet weed delivery in Rye, NY, so you can
                                        order online and get your products directly deliver to your doorstep—safe,
                                        secure, and stress-free.</p>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="boxes-four text-center mt-4">
                                    <h4>Owned by women. Community-oriented.</h4>
                                    <p>Highlife Health was founded by Jennifer Gierum and the goal of transforming the
                                        cannabis experience by making it more welcoming, encouraging, and stigma-free.
                                        We don't just sell; we take the time to listen and offer guidance.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <figure>
                            <img src="assets/images/buy-weedUs.jpg" alt="Weed Dispensary Rye NY" class="bor-15">
                        </figure>
                    </div>
                </div>
                <h2 class="mb-3 mt-5 text-center">How It Works — Easy Weed Delivery in Rye, NY</h2>
                <div class="row align-items-stretch">
                    <div class="col-md-4">
                        <div class="boxes-four text-center boxes-coloring">
                            <h4 class="coloRew">Look Through Our Menu</h4>
                            <p>Explore our online shop anytime; everything is labeled with flavors, effects, and usage
                                instructions.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="boxes-four text-center boxes-coloring">
                            <h4 class="coloRew">Place Your Order</h4>
                            <p>Select pickup or choose weed delivery to Rye, NY. Our system is simple and fast.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="boxes-four text-center boxes-coloring">
                            <h4 class="coloRew">Relax and Enjoy</h4>
                            <p>The rest will be taken care of by us. Always expect top-notch products and discreet,
                                professional service. </p>
                        </div>
                    </div>
                </div>

                <h2 class="mb-3 mt-5 text-center">What Makes Us Different</h2>
                <div class="row mt-5">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="boxes-four text-center">
                                    <img src="assets/images/licensed.png" alt="Licensed & Fully Compliant">
                                    <h4>Licensed & Fully Compliant</h4>
                                    <p>No sketchy products here; everything we offer is legal, tested, and safe.</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="boxes-four text-center">
                                    <img src="assets/images/guidance.png" alt="Real Guidance, No Pressure">
                                    <h4>Real Guidance, No Pressure</h4>
                                    <p>Our budtenders are friendly and informed. Our goal is to assist you in
                                        determining what suits you.</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="boxes-four text-center mt-4">
                                    <img src="assets/images/happycustomers.png" alt="Hundreds of Happy Customers">
                                    <h4>Hundreds of Happy Customers</h4>
                                    <p>People adore our friendly service, high-quality products, and simple ordering
                                        process, as evidenced by our 4.6+ star ratings.</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="boxes-four text-center mt-4">
                                    <img src="assets/images/convenient.png" alt="Convenient and nearby">
                                    <h4>Convenient and nearby</h4>
                                    <p>You don’t need to search far and wide—Highlife Health is your go-to weed
                                        dispensary for Rye, NY residents.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <figure>
                            <img src="assets/images/whyus.png" alt="Weed Delivery Rye NY" class="bor-15">
                        </figure>
                    </div>
                </div>
                <h2 class="mt-3">Are You All Set to Place Your Order? Let's simplify things. </h2>
                <p class="mb-2">We can help, whether you're new to cannabis or simply searching for a reliable
                    dispensary. Cannabis should enhance your life, not make it more difficult, according to Highlife
                    Health. So relax, look over our selection, and take advantage of quick, safe cannabis delivery in
                    Rye, NY right now.</p>



            </div>


            <div class="abtclas pt-3">
                <h3><b>Fast Cannabis & Vape Delivery in These Areas</b></h3>
                <p>We proudly deliver high-quality cannabis, vapes, edibles, and pre-rolls across multiple NY locations.
                    Check out
                    our
                    nearby service areas below.</p>

                <div class="weed-location-grid">

                    <div class="location-box">
                        <a routerLink="/Cannabis_Delivery_Larchmont_NY">
                            <h4>Larchmont NY</h4>
                            <p>Cannabis Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Disposable_Vapes_Larchmont_NY">
                            <h4>Larchmont NY</h4>
                            <p>Vape Delivery</p>
                        </a>

                    </div>

                    <div class="location-box">
                        <a routerLink="/Buy_Weed_Online_in_Rye">
                            <h4>Rye NY</h4>
                            <p>Weed Delivery</p>
                        </a>

                    </div>


                    <div class="location-box">
                        <a routerLink="/Buy_Edibles_Online_Rye">
                            <h4>Rye NY</h4>
                            <p>Edibles Delivery</p>
                        </a>

                    </div>

                    <div class="location-box">
                        <a routerLink="/Buy_Pre_Rolls_Online_in_Rye_NY">
                            <h4>Rye NY</h4>
                            <p>Pre Rolls Delivery</p>
                        </a>

                    </div>

                    <div class="location-box">
                        <a routerLink="/Cannabis_Delivery_Mamaroneck_NY">
                            <h4>Mamaroneck NY</h4>
                            <p>Cannabis Delivery</p>
                        </a>
                    </div>

                    <div class="location-box">
                        <a routerLink="/Vape_Pen_Cartridges_Mamaroneck_NY">
                            <h4>Mamaroneck NY</h4>
                            <p>Vape Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Weed_Delivery_Mamaroneck_NY">
                            <h4>Mamaroneck NY</h4>
                            <p>Weed Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Cannabis_Delivery_bronx_NY">
                            <h4>Bronx NY</h4>
                            <p>Cannabis Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Weed_Delivery_Bronx_NY">
                            <h4>Bronx NY</h4>
                            <p>Weed Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/Vape_Pen_Cartridges_Bronx_NY">
                            <h4>Bronx NY</h4>
                            <p>Vape Delivery</p>
                        </a>
                    </div>
                    <div class="location-box">
                        <a routerLink="/THC_Drinks_in_Bronx">
                            <h4>Bronx NY</h4>
                            <p>THC Drinks</p>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>


</main>